import t from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as o } from "@semcore/utils/lib/core/index";
import a, { sstyled as p, assignProps as d } from "@semcore/core";
import _ from "react";
import s from "../Box/index.mjs";
var i = (
  /*__reshadow_css_start__*/
  (o.insert(
    /*__inner_css_start__*/
    ".___SScreenReaderOnly_ro3ht_gg_{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;white-space:nowrap;border-width:0;left:-1px;top:-1px}",
    "ro3ht_gg_"
  ), {
    __SScreenReaderOnly: "___SScreenReaderOnly_ro3ht_gg_"
  })
), l = function() {
  var r = arguments[0], e, n = s;
  return e = p(i), /* @__PURE__ */ _.createElement(n, e.cn("SScreenReaderOnly", t({}, d({
    tag: "span"
  }, r))));
}, h = a(l);
export {
  h as ScreenReaderOnly,
  h as default
};
